/*
  * Returns the first key in the map that satisfies the predicate.
  * If no key satisfies the predicate, returns undefined.
  */
export const findMapKey = <K, V>(m: Map<K, V>, predicate: (v: V) => boolean): K | undefined => {
  for (const [k, v] of m) {
    if (predicate(v)) {
      return k;
    }
  }
  return undefined;
};

/*
  * Returns the value at the given index in the map.
  * If the map is undefined or the index is out of bounds, returns undefined.
  */
export const getMapAt = <K, V>(m: Map<K, V> | undefined, n: number): V | undefined => {
  if (!m) {
    return undefined;
  }
  if (n < 0) {
    return undefined;
  }
  const it = m.entries();
  for (; ;) {
    const res = it.next();
    if (res.done) {
      return undefined;
    }
    if (n === 0) {
      return res.value[1];
    }
    --n;
  }
};
